const categoryRedirect = () => {
  const redirect = e => window.location.href = e.target.value;

  const init = () => {
    const categoriesSelect = document.querySelector('select[name=categories]');
    if (categoriesSelect) {
      categoriesSelect.addEventListener('change', redirect);
    }
  };

  init();
};

export default categoryRedirect;
